<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousAir"
            >&laquo; Back</md-button>
          </md-layout>

          <md-layout md-flex="30"></md-layout>

          <md-layout md-flex>
            <h2>Tracking(Sea Conso)</h2>
            <md-layout md-flex="45"></md-layout>
            <md-layout md-flex="30"></md-layout>
          </md-layout>
        </md-layout>
        <hr class="hr-s" />

        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="25">
            <label>Assignment No.</label>

            <b-form-input :formatter="capitalizeAll" v-model="mainPageModal.conSeaImportSeries" disabled />
          </md-layout>
        </md-layout>
        <hr class="hr-border" />
        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <label for="conSeaMultiBlId">HAWBL No.</label>
            <model-list-select
              option-value="conSeaMultiBlId"
              option-text="secondBLNumber"
              :list="HAWBLNoList"
              placeholder="Select HAWBL No."
              v-model="docModal.conSeaMultiBlId"
            ></model-list-select>
            <span class="error" v-if="!docModal.conSeaMultiBlId">{{errorDocModal.conSeaMultiBlId}}</span>
          </md-layout>

          <md-layout md-flex="20">
            <label for="trackingDoc">Document</label>
            <model-list-select
              option-value="trackingDocVal"
              option-text="trackingDocText"
              :list="trackingDocList"
              placeholder="Select Document "
              v-model="docModal.trackingDoc"
            ></model-list-select>
            <span class="error" v-if="!docModal.trackingDoc">{{errorDocModal.trackingDoc}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-input-container>
              <label>Upload Document</label>

              <md-file
                name="trackDocUpload"
                id="trackDocUpload"
                v-model="docModal.trackDocUpload"
                @selected="onFileChangetracking"
                multiple
              ></md-file>
            </md-input-container>
            <span class="error" v-if="!docModal.trackDocUpload">{{errorDocModal.trackDocUpload}}</span>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <label>Receiving Date</label>
            <date-picker
            :format="selectDateFormat"
              lang="en"
              id="receivingDate"
              name="receivingDate"
              v-model="docModal.receivingDate"
            ></date-picker>
            <span class="error" v-if="!docModal.receivingDate">{{errorDocModal.receivingDate}}</span>
          </md-layout>

          <md-layout md-flex="10">
            <md-button
              style="margin-top:20px"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              id="addButtonLoader1"
              @click="addTrack('')"
            >Upload</md-button>
            <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>
        <md-layout md-gutter v-if="trackingUploadView.length >0">
          <md-layout md-flex="50"></md-layout>
          <md-layout md-flex="15" v-for="(item,index) in trackingUploadView" :key="index">
            <a
              :href="`${this.docURL}/dummy`+item"
              target="_blank"
              download
            >View Document - {{index+1}}</a>
          </md-layout>
        </md-layout>
        <hr class="hr-border" v-if="docTableData.length>0" />
        <div class="box" v-if="docTableData.length>0">
          <div class="box-header">
            <h3 class="box-title">Document Details</h3>
          </div>

          <!-- /.box-header -->
          <div class="box-body">
            <table id="ffBookingTentative" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>HAWBL No.</th>
                  <th>Document</th>
                  <th>Receiving Date</th>

                  <th>View Doc</th>
                  <!--  <th>Delete</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in docTableData" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.HAWBLNo }}</td>
                  <td>{{item.trackingDoc }}</td>
                  <td>{{item.receivingDate | moment }}</td>

                  <md-button
                    class="md-icon-button md-raised md-dense"
                    @click="viewDoc(item.trackDocUpload)"
                  >
                    <md-icon>visibility</md-icon>
                  </md-button>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
        <hr class="hr-border" />

        <md-layout
          md-gutter
          v-if="mainPageModal.cargoDestufLocationId!=mainPageModal.PODLocationId"
        >
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <h3>
              <u>Rail Out</u>
            </h3>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <label>Destuffing Date</label>
            <date-picker
            :format="selectDateFormat"
              lang="en"
              id="arivalDatePort"
              name="arivalDatePort"
              v-model="BookingShippingLine.destuffingDate"
            ></date-picker>
          </md-layout>
        </md-layout>

        <md-layout
          md-gutter
          class="labelMargtop"
          v-if="mainPageModal.cargoDestufLocationId!=mainPageModal.PODLocationId"
        >
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="20">
            <label>Train No.</label>
            <b-form-input :formatter="capitalizeAll" name="trainNo" id="trainNo" v-model="BookingShippingLine.trainNo"></b-form-input>
          </md-layout>
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="25">
            <label>Wagon No.</label>
            <b-form-input :formatter="capitalizeAll" name="wagonNo" id="wagonNo" v-model="BookingShippingLine.wagonNo"></b-form-input>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <label>Date</label>
            <date-picker
            :format="selectDateFormat"
              lang="en"
              id="trainDate"
              name="trainDate"
              v-model="BookingShippingLine.trainDate"
            ></date-picker>
          </md-layout>
        </md-layout>
        <md-layout
          md-gutter
          class="labelMargtop"
          v-if="mainPageModal.cargoDestufLocationId!=mainPageModal.PODLocationId"
        >
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <label>Actual Arrival Date(FPOD)</label>
            <date-picker
            :format="selectDateFormat"
              lang="en"
              id="actualAriveDateFPOD"
              name="actualAriveDateFPOD"
              v-model="BookingShippingLine.actualAriveDateFPOD"
            ></date-picker>
          </md-layout>
        </md-layout>
        <hr class="hr-border" />
        <md-layout md-gutter>
          <md-layout md-flex="45"></md-layout>
          <md-layout md-flex="30">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              id="addButtonLoader1"
              @click="addTrack('pqrst')"
            >Submit</md-button>
            <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>
      </md-card-content>
    </md-card>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop2"
      @close="onCloseProceed"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopAddTracking"
      @close="onCloseAddTracking"
    ></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { FormInput } from "bootstrap-vue";
import { FormFile } from "bootstrap-vue";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editconSeaImportId") != "" &&
      this.$sessionsStorage.get("editconSeaImportId") != undefined
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/conSeaImport/conSeaImportTracking"
      );

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }

    // this.vehicle();
  },
  beforeDestroy() {},
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      types: [
        "text",
        "password",
        "email",
        "number",
        "url",
        "tel",
        "date",
        `time`,
        "range",
        "color"
      ],
      editorOption: {
        modules: {}
      },
      editorContent: "",
      isLoading: false,
      trackingDocList: [
        {
          trackingDocVal: "CoO",
          trackingDocText: "CoO"
        },
        {
          trackingDocVal: "Invoice",
          trackingDocText: "Invoice"
        },
        {
          trackingDocVal: "PackingList",
          trackingDocText: "Packing List"
        },
        {
          trackingDocVal: "BIS",
          trackingDocText: "BIS"
        },
        {
          trackingDocVal: "Bill_Of_Entry",
          trackingDocText: "Bill Of Entry"
        },
        {
          trackingDocVal: "Pridel_Invoice",
          trackingDocText: "Pridel Invoice"
        },
        {
          trackingDocVal: "Factory_Destuffing_Bond",
          trackingDocText: "Factory Destuffing Bond"
        },
        {
          trackingDocVal: "Overseas_Agent_Invoice",
          trackingDocText: "Overseas Agent Invoice"
        },
        {
          trackingDocVal: "Line_DO",
          trackingDocText: "Line DO"
        },
        {
          trackingDocVal: "Offloading_Letter",
          trackingDocText: "Offloading Letter"
        },
        {
          trackingDocVal: "OtherDoc",
          trackingDocText: "Other Document"
        }
      ],

      value12: "",
      getCLientData: ["gfdg"],
      getHAWBLData: ["gfdg"],
      multiHAWBL: [],
      finalCargoDeliveryDate: [],

      BookingShippingLine: {
        airImportTrackId: "",
        conSeaImportId: "",
        destuffingDate: "",
        trainNo: "",
        wagonNo: "",
        trainDate: "",
        actualAriveDateFPOD: ""
      },
      docModal: {
        conSeaImportId: "",
        seaConImportTrackId: "",
        seadocId: "",
        trackingDoc: "",
        trackDocUpload: "",
        receivingDate: "",
        conSeaMultiBlId: "",
        HAWBLNo: ""
      },
      execError: [
        "Select Transhipment",
        "Select IGM Filing Date",
        "Select From Port",
        "Select To Port",
        "Select ETD Date",
        "Select ETA Date",
        "Enter Flight No"
      ],
      errorBookingShippingLine: {
        bookingShipment: "",
        igmFilingDate: "",
        fromPort: "",
        toPort: "",
        etdFromPort: "",
        etaToPort: "",
        flightNo: ""
      },

      portMasterList: [],
      docTableData: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      mainPageModal: {
        PODLocationId: "",
        containerInfo: "",
        conSeaImportSeries: "",
        cargoDestufLocationId: ""
      },
      errorDo: [
        "Select HAWBL No.",
        "Select Document",
        "Upload Document",
        "Select Receiving Date"
      ],
      errorDocModal: {
        conSeaMultiBlId: "",
        trackingDoc: "",
        trackDocUpload: "",
        receivingDate: ""
      },

      HAWBArray: [],
      agentMasterList: [],
      deleteId: "",
      validate: true,
      validateTrans: true,
      arrayErrorAirport: [
        "Select From Port",
        "Select To Port",

        "Select ETA Date",
        "Enter Flight No"
      ],
      errorAirport: {
        fromPort: "",
        toPort: "",

        etaToPort: "",
        flightNo: ""
      },
      showAddAirport: false,

      editIndex: ""
    };
  },

  mounted() {},
  watch: {
    docModal: {
      handler: function(newVal, oldVal) {
        if (this.docModal.conSeaMultiBlId != "") {
          let arrayHAWBLId = this.multiHAWBL.filter(x => {
            return x.conSeaMultiBlId == this.docModal.conSeaMultiBlId;
          });

          if (arrayHAWBLId.length > 0) {
            this.docModal.HAWBLNo = arrayHAWBLId[0].secondBLNumber;
          }
        }
      },

      deep: true
    }
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    FormInput,
    FormFile
  },
  computed: {
    HAWBLNoList() {
      return this.multiHAWBL;
    },

    trackingUploadView() {
      return this.docModal.trackDocUpload != ""
        ? this.docModal.trackDocUpload.split(",")
        : [];
    },

    portList() {
      return this.portMasterList;
    },

    bookingShipmentList() {
      return this.bookingShipmentName;
    }
  },
  methods: {
    viewDoc(id) {
      window.open(
        "https://uploadsp.pridel.com/ConSeaImportTracking/" + id
      );
    },
    doLoading() {
      this.isLoading = true;
    },

    validateUploadDoc() {
      let validate_new = true;
      Object.keys(this.errorDocModal).map((x, index) => {
        if (this.docModal[x] == "") {
          this.errorDocModal[x] = this.errorDo[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");

      return dateNew;
    },
    addTrack(id) {
      this.BookingShippingLine["conSeaImportId"] = this.$sessionsStorage.get(
        "editconSeaImportId"
      );
      this.docModal["conSeaImportId"] = this.$sessionsStorage.get(
        "editconSeaImportId"
      );

      $("#addButtonLoaderSub").css("display", "none");
      $("#loaderSub").css("display", "block");

      let newData = {
        docModal: this.docModal,
        normalTrackingModal: this.BookingShippingLine
      };
      if (id == "") {
        newData["onlyExecMain"] = "";
      } else {
        newData["onlyExecMain"] = "pqrst";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/conSeaImpaddTracking.php`,
        data: JSON.stringify(newData),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            $("#loaderSub").css("display", "none");
            $("#addButtonLoaderSub").css("display", "block");

            if (this.BookingShippingLine.seaConImportTrackId == "") {
              this.alert.content = "Data Added Successfully";
              this.$refs["addPopAddTracking"].open();
            } else {
              this.alert.content = "Data Updated Successfully";
              this.$refs["addPopAddTracking"].open();
            }

            this.BookingShippingLine.seaConImportTrackId =
              data.seaConImportTrackId;
            this.getData();
          }
        })
        .catch(error => {});
    },

    onCloseAddTracking() {},

    onFileChangetracking() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId")
        }
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`, formData, config)
        .then(result => {
          this.docModal.trackDocUpload = result.data;
        })
        .catch(err => {
          throw err;
        });
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onCloseProceed() {},
    onClose6(type) {},

    viewEdit(item, index) {
      this.showAddAirport = true;
      Object.keys(this.moreAirportModel).map(x => {
        this.moreAirportModel[x] = item[x];
      });
    },
    DeleteList(item, index) {
      this.deleteId = item.moreAirportId;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    previousAir() {
      this.$router.push({
        path: "/conSeaImport/ffConSeaImportExec"
      });
    },

    validateExec() {
      let validate_new = true;

      Object.keys(this.errorBookingShippingLine).map((x, index) => {
        if (this.BookingShippingLine[x] == "") {
          this.errorBookingShippingLine[x] = this.execError[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ffBookingTentative").DataTable();
    //   });
    // },
    getData() {
      this.doLoading();

      let new_data = {
        conSeaImportId: this.$sessionsStorage.get("editconSeaImportId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/conGetDataSeaImportTrack.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            if (data.ConsoSeaImportData.length > 0) {
              Object.keys(this.mainPageModal).map(x => {
                this.mainPageModal[x] = data.ConsoSeaImportData[0][x] || "";
              });
            }
            console.log(this.mainPageModal);
            if (data.ConSeaImportMultiHouseData.length > 0) {
              this.multiHAWBL = data.ConSeaImportMultiHouseData;
            }
            if (data.SeaImportTrackData.length > 0) {
              Object.keys(this.BookingShippingLine).map(x => {
                this.BookingShippingLine[x] =
                  data.SeaImportTrackData[0][x] || "";
              });
            }

            if (data.SeaTrackMultipleDoc.length > 0) {
              this.docTableData = data.SeaTrackMultipleDoc;
            }

            this.doLoadingClose();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// conSeaImportTracking.vue?3cbd2048